import styled from "styled-components";

const ContentCard = ({
  image,
  title,
  subtitle,
  description,
  onBlog,
  onLike,
}) => (
  <CardContainer>
    <CardImage
      src={image}
      alt="Profile"
      loading="eager"
      decoding="async"
      fetchPriority="high"
    />
    <CardContent>
      <Title>{title}</Title>
      <Subtitle>{subtitle}</Subtitle>
      <Description>{description}</Description>
      <ButtonContainer>
        <Button onClick={onBlog}>Blog</Button>
        <PrimaryButton onClick={onLike}>Like</PrimaryButton>
      </ButtonContainer>
    </CardContent>
  </CardContainer>
);

export default ContentCard;

// Styled Components
const CardContainer = styled.div`
  display: flex;
  align-items: center;
  width: 75vw;
  max-width: 700px;
  padding: 100px 100px 120px 120px;
  background: #121017;
  border-radius: 24px;

  [data-auth-theme="night"] & {
    background: var(--app-surface, #2b2b2b);
  }
  box-shadow: 0 80px 60px rgba(0, 0, 0, 0.12);

  @media (max-width: 600px) {
    margin: 10px;
    padding: 50px;
    width: 100%;
    text-align: center;
    flex-direction: column;
  }

  @media (max-width: 420px) {
    padding: 40px 80px;
    width: 87vw; /* Almost full width for extra small screens */
  }
`;

const CardImage = styled.img`
  max-width: 280px;
  width: 32vw;
  height: 300px;
  object-fit: cover;
  margin-left: -170px;
  margin-right: 130px;
  border-radius: inherit;
  box-shadow: 0 60px 40px rgba(0, 0, 0, 0.12);
  transition: border-radius 0.3s;

  @media (max-width: 600px) {
    margin: -100px 0 30px 0;
    width: 100%;
    max-width: 1000px;
    height: 250px;
  }

  @media (max-width: 420px) {
    height: 50vw;
    width: 50vw;
    border-radius: 50%;
    margin: -140px 10px 30px 100;
  }
`;

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.h2`
  font-size: 26px;
  font-weight: 400;
  margin: 0 0 70px 0;
  color: #d1d1d1;

  @media (max-width: 600px) {
    font-size: 26px;
    margin: 0;
  }
`;

const Subtitle = styled.h3`
  font-size: 16px;
  font-weight: 400;
  margin: 0 0 12px;
  opacity: 0.85;
  color: #b0b0b0;
`;

const Description = styled.p`
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 30px;
  opacity: 0.65;
  color: #8e8e8e;

  @media (max-width: 600px) {
    max-width: 400px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;

  @media (max-width: 600px) {
    justify-content: center;
  }
`;

const Button = styled.button`
  border: 1px solid #f8f8f8;
  background: transparent;
  color: #f8f8f8;
  width: 40%;
  min-width: 100px;
  text-align: center;
  font-family: inherit;
  padding: 12px 26px;
  font-size: 16px;
  border-radius: 40px;

  @media (max-width: 600px) {
    width: 50%;
  }

  &:hover {
    animation: shake 400ms ease-in-out; /* 在懸停時觸發 shake 動畫 */
  }

  /* 定義 shake 動畫 */
  @keyframes shake {
    0% {
      rotate: 0deg;
    }
    30% {
      rotate: 7deg;
    }
    60% {
      rotate: -7deg;
    }
    100% {
      rotate: 0deg;
    }
  }
`;

const PrimaryButton = styled(Button)`
  background: #ffffff;
  color: #121017;
  position: relative; /* 為了讓 ::after 使用相對定位 */

  &::after {
    content: "★"; /* Unicode 星號 */
    position: absolute;
    top: -10px; /* 根據需要調整 */
    left: 75%;
    transform: translateX(-50%) scale(0.5) rotate(0deg);
    font-size: 30px; /* 調整星星大小 */
    color: gold; /* 星星顏色 */
    opacity: 0; /* 初始為隱藏 */
    pointer-events: none; /* 防止鼠標事件 */
  }

  &:hover::after {
    animation: star-fade-animation 700ms ease-in-out forwards;
  }

  &:hover {
    animation: shake-animation 400ms ease-in-out;
  }

  /* 星星淡入淡出動畫 */
  @keyframes star-fade-animation {
    0% {
      opacity: 0;
      transform: translateX(-50%) scale(0.5) rotate(0deg);
    }
    50% {
      opacity: 1;
      transform: translateX(-50%) scale(1) rotate(40deg);
    }
    100% {
      opacity: 0;
      transform: translateX(-50%) scale(1) rotate(70deg);
    }
  }

  /* 按鈕左右晃動動畫 */
  @keyframes shake-animation {
    0% {
      transform: translateX(0);
    }
    25% {
      transform: translateX(-4px);
    }
    50% {
      transform: translateX(4px);
    }
    75% {
      transform: translateX(-4px);
    }
    100% {
      transform: translateX(0);
    }
  }
`;
